import { render, staticRenderFns } from "./CardItemBaseContainer.vue?vue&type=template&id=6375bc5e"
import script from "./CardItemBaseContainer.vue?vue&type=script&lang=ts"
export * from "./CardItemBaseContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6375bc5e')) {
      api.createRecord('6375bc5e', component.options)
    } else {
      api.reload('6375bc5e', component.options)
    }
    module.hot.accept("./CardItemBaseContainer.vue?vue&type=template&id=6375bc5e", function () {
      api.rerender('6375bc5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardItemBaseContainer.vue"
export default component.exports